// extracted by mini-css-extract-plugin
export default {"searchBar":"SearchBar_searchBar__YkCoI","searchInput":"SearchBar_searchInput__JrW2V"};